export enum CompareFilterEnum {
  PREVIOUS_PERIOD = 'pp',
  YEAR_OVER_YEAR = 'yoy'
}
